    import React, { useCallback, useEffect, useMemo, useState, Suspense } from "react";
    import {
    deleteItem,
    fetchData,
    toggleStatus,
    } from "../../../utils/apiUtils";
    import {
    PlusButton,
    } from "../../../helper/ImageFormat";
    import DeleteModel from "../../../Components/DeleteModel";
    import Breadcrumb from "../../../helper/Breadcrumb";
import CollectionTable from "./collectionTable";
import { useNavigate } from "react-router-dom";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";

    const Collection = () => {
         const navigator = useNavigate();
        
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [deleteItemId, setDeleteItemId] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const totalPages = useMemo(() => Math.ceil(totalCount / perPage), [totalCount, perPage]);
   const [nextPosition, setNextPosition] = useState(0);
   

    const fetchPaginationData = useCallback(
        async (page = 1, searchQuery = "") => {
        setLoading(true);
        await fetchData(
            "collection-pagination",
            { perPage, pageNo: page, search: searchQuery },
            setData,
            setTotalCount,
            setCurrentPage,
            setLoading,
            setNextPosition
        );
        },
        [perPage]
    );

    useEffect(() => {
        const delay = search ? 500 : 0;
        const handler = setTimeout(() => {
        fetchPaginationData(currentPage, search);
        }, delay);
        return () => clearTimeout(handler);
    }, [search, perPage]);

    const handleDelete = (data) => {
        setDeleteItemId(data);
        setDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
        const res=await deleteItem("collection", deleteItemId?.id, fetchPaginationData);
        setDeleteItemId({});
        setDeleteModalOpen(false);
        return res
        } catch (error) {
      return error;
    } finally {
        setIsDeleting(false);
        }
    };

    const handleStatusToggle = async (currency) => {
        const data = await toggleStatus("collection-status", currency?.id, fetchPaginationData);
        if (Object.keys(data).length > 0) {
        setData((prev) =>
            prev.map((curr) =>
            curr.id === currency.id ? { ...curr, isActive: data?.isActive } : curr
            )
        );
        }
    };

    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
        fetchPaginationData(page);
        }
    };

   

    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Collections", path: "/collection" },
    ];

  

     const handleAdd = () => {  
    navigator("/add-collection",{state:{nextPosition}});
  };

    const handleEditClick = (item) => {
    navigator("/add-collection", {
      state: item,
    });
  };



    return (
        <>
        <div className="content-wrapper">
            <div className="page-header mt-5 d-flex justify-content-between">
            <h3 className="custom-page-title">Collections</h3>
            <Breadcrumb items={breadcrumbdata} />
            </div>

            <div className="d-flex justify-content-between mb-2 bg-white p-2" style={{ marginTop: "-20px" }}>
            <PerPageSelect value={perPage} onChange={setPerPage}/>

            <div style={{ display: "flex", gap: "10px" }}>
                <TableSearch value={search} onChange={setSearch} />

                <PlusButton handleAdd={handleAdd} module={"Collection"} />

            </div>
            </div>

            <CollectionTable
            loading={loading}
            data={data}
            currentPage={currentPage}
            perPage={perPage}
            totalPages={totalPages}
            totalCount={totalCount}
            handlePageClick={handlePageClick}
            handleEditClick={handleEditClick}
            handleDelete={handleDelete}
            handleStatusToggle={handleStatusToggle}
            selected={selected}
            setSelected={setSelected}
            />
        </div>

   
        

        <Suspense fallback={<div>Loading...</div>}>
            <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="Collection"
            isDeleting={isDeleting}
            />
        </Suspense>
        </>
    );
    };

    export default Collection;
